import { Tooltip, Typography } from '@mui/material';
import clsx from 'clsx';
import React, { FC, useState, useEffect } from 'react';
import { useViewport } from '../../../hooks';
import { cn } from '@thingslog/ui-components';

export const SensorDisplay: FC<SensorDisplayProps> = ({
  isSelected,
  label,
  name,
  onClick,
  isBlocked,
}: SensorDisplayProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const isMobile = useViewport('sm');

  const handleMouseEnter = (): void => {
    setIsHovered(true);
  };

  const handleMouseLeave = (): void => {
    setIsHovered(false);
  };

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={(): void => {
        if (onClick !== undefined && isBlocked !== true) {
          onClick();
        }
      }}
      className={clsx(
        'flex min-h-[4.5rem] w-[7.75rem] max-w-full min-w-0 flex-col justify-between overflow-hidden rounded-lg border cursor-pointer select-none',
        isSelected ? 'border-solid' : 'border-dashed',
        isSelected || isHovered ? 'border-gray-400' : 'border-gray-300',
        isHovered && 'shadow-sm',
        isBlocked && 'cursor-not-allowed opacity-50'
      )}
    >
      <div
        className={clsx(
          'flex items-center justify-center ',
          'px-1.5 py-1',
          isSelected
            ? 'bg-gradient-to-br from-portal-teal to-portal-seagreen text-white font-semibold'
            : 'bg-white text-gray-600 font-normal',
          !isSelected && !isHovered && 'border border-x-0 border-t-0 border-gray-300 border-dashed',
          !isSelected && isHovered && 'border border-x-0 border-t-0 border-gray-400 border-dashed'
        )}
      >
        <Tooltip title={name} placement="top" enterDelay={2000} enterNextDelay={2000}>
          <Typography variant="body2" className="text-center line-clamp-1 break-all">
            {name}
          </Typography>
        </Tooltip>
      </div>
      <div className={cn('flex flex-grow items-center justify-center text-center', 'px-1.5 py-1')}>
        <Typography
          variant={isMobile ? 'body2' : 'body1'}
          sx={{ fontWeight: 600 }}
          className=" break-words"
        >
          {label}
        </Typography>
      </div>
    </div>
  );
};

interface SensorDisplayProps {
  name: string;
  label: string;
  onClick?: () => void;
  isSelected: boolean;
  isBlocked?: boolean;
}
